"use client";
import Stack from "@casino/legacy/client/shared/Stack";
import BrandThemeProvider from "../Shared/BrandThemeProvider";
import RegisterBody from "./RegisterBody";
import RegisterBottomLinks from "./RegisterBody/RegisterBottomLinks";

type Props = {
  onSuccess?: () => void;
  isPopover?: boolean;
  isLanguageSwitcherHidden?: boolean;
};
const Register: FC<Props> = ({
  onSuccess,
  isPopover,
  isLanguageSwitcherHidden,
}) => (
  <Stack templateRows="minmax(1px,1fr) minmax(1px,180px)" gridGap="1.5rem">
    <RegisterBody handleSuccess={onSuccess} isPopover={isPopover} />
    <BrandThemeProvider>
      <RegisterBottomLinks
        isPopover={isPopover}
        isLanguageSwitcherHidden={isLanguageSwitcherHidden}
      />
    </BrandThemeProvider>
  </Stack>
);

export default Register;
